"use client";

import { c as _c } from "react/compiler-runtime";
import { Description, Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import clsx from "clsx";
import { FC, Fragment } from "react";
export interface ModalProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  className?: string;
  blur?: boolean;
  maxWidth?: number | string;
  fillMobile?: boolean;
  padding?: boolean;
  children?: any;
}
export const ModalTitle: FC<any> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <DialogTitle {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const ModalDescription: FC<any> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Description {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const Modal = t0 => {
  const $ = _c(30);
  const {
    fillMobile,
    isOpen,
    setIsOpen,
    children,
    className,
    blur,
    padding: t1,
    maxWidth
  } = t0;
  const padding = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== setIsOpen) {
    t2 = () => setIsOpen && setIsOpen(false);
    $[0] = setIsOpen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== blur) {
    t3 = clsx("fixed w-screen h-screen flex justify-center items-center bg-neutral-875 bg-opacity-25 top-none left-none z-50", {
      "backdrop-blur-sm": blur
    });
    $[2] = blur;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <TransitionChild as={Fragment as any} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className={t3} /></TransitionChild>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== fillMobile) {
    t5 = clsx("flex flex-1 justify-center", {
      "h-full m:h-auto": fillMobile
    });
    $[6] = fillMobile;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== maxWidth) {
    t6 = {
      maxWidth
    };
    $[8] = maxWidth;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !fillMobile;
  const t8 = !fillMobile;
  let t9;
  if ($[10] !== className || $[11] !== fillMobile || $[12] !== padding || $[13] !== t7 || $[14] !== t8) {
    t9 = clsx("bg-neutral-0 flex flex-col gap overflow-y-auto shadow-3", {
      "h-full w-screen m:w-auto m:h-auto m:max-w-[700px] m:max-h-[calc(100vh-32px)] items-center": fillMobile,
      "m:max-h-[calc(100vh-32px)] max-w-[700px]": t7,
      "m:rounded-m m:m-s": fillMobile,
      "m-s rounded-m": t8,
      "p-2s s:p-2m": padding
    }, className);
    $[10] = className;
    $[11] = fillMobile;
    $[12] = padding;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== children || $[17] !== t6 || $[18] !== t9) {
    t10 = <DialogPanel style={t6} className={t9}>{children}</DialogPanel>;
    $[16] = children;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <div className="fixed inset-none flex h-screen-safe items-center justify-center z-50"><TransitionChild as={Fragment as any} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"><div className={t5}>{t10}</div></TransitionChild></div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t2 || $[25] !== t4) {
    t12 = <Dialog onClose={t2}>{t4}{t11}</Dialog>;
    $[23] = t11;
    $[24] = t2;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isOpen || $[28] !== t12) {
    t13 = <Transition appear={true} show={isOpen} as={Fragment as any}>{t12}</Transition>;
    $[27] = isOpen;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default Object.assign(Modal, {
  Title: ModalTitle,
  Description: ModalDescription
});